exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-spinner[data-v-efe9d588] {\n  display: inline-block;\n  border-radius: 50%;\n  animation: spin-efe9d588 1s ease-in-out infinite;\n  vertical-align: middle;\n  margin-right: 5px;\n  position: relative;\n  top: -1px;\n  border-style: solid;\n}\n@keyframes spin-efe9d588 {\nto {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
